// Functions for managing the Local Storage

export const getFromLocalStorage = (key) =>
  JSON.parse(localStorage.getItem(key));

export const saveToLocalStorage = (key, data) => {
  const item = localStorage.setItem(key, JSON.stringify(data));
  return item;
};
